import { Link } from "../router";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
    return (
        <nav className="flex items-center gap-2 text-xs font-bold tracking-widest uppercase w-full">
            <Link to="/" className="text-[#666] hover:text-white transition-colors flex items-center gap-1">
                HOME
            </Link>

            {items.map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                    <span className="text-[#333] text-[10px] mx-1">/</span>
                    {item.href ? (
                        <Link to={item.href} className="text-[#666] hover:text-white transition-colors">
                            {item.label}
                        </Link>
                    ) : (
                        <span className="text-white line-clamp-1 max-w-[200px] md:max-w-none">
                            {item.label}
                        </span>
                    )}
                </div>
            ))}
        </nav>
    );
}
